import { API_HOST, getHttpPostOptions, getHttpGetOptions, getHttpDeleteOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/comment`;
const getSpecificEndpoint = (externalReference) => `${getEndpoint()}/${externalReference}`;
const getViewCommentsEndpoint = (postExternalReference, page, size) =>
  `${getSpecificEndpoint(postExternalReference)}/${page}/${size}`;

export const getCreateCommentRequest = (comment) => [getEndpoint(), getHttpPostOptions(comment)];

export const getViewCommentsRequest = (postExternalReference, page, size) => [
  getViewCommentsEndpoint(postExternalReference, page, size),
  getHttpGetOptions()
];

export const getDeleteCommentRequest = (commentExternalReference) => [
  `${getSpecificEndpoint(commentExternalReference)}`,
  getHttpDeleteOptions()
];
